import { render, staticRenderFns } from "./EditTabDocument.vue?vue&type=template&id=19af0d31"
import script from "./EditTabDocument.vue?vue&type=script&lang=js"
export * from "./EditTabDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports